
const caracteristiques = {
  acideEruciqueTaux: 'TAUX_ACIDE_ERUCTIQUE',
  calibrageTaux: 'TAUX_CALIBRAGE',
  daturaPresent: 'PRESENCE_DATURA',
  echaudeBriseTaux: 'TAUX_ECHAUDE_BRISE',
  ergotPresentt: 'PRESENCE_ERGOT',
  flairAnormal: 'FLAIR_ANORMAL',
  forceBoulangere: 'FORCE_BOULANGERE',
  germeMitadineFusarieTaux: 'TAUX_GERME_MITADINE_FUSARIE',
  grainBrucheTaux: 'TAUX_BRUCHE',
  grainsBrulesTaux: 'TAUX_BRULE',
  grainCasseTaux: 'TAUX_CASSE',
  grainGermeTaux: 'TAUX_GERME',
  huileTaux: 'TAUX_HUILE',
  humiditeTaux: 'TAUX_HUMIDITE',
  impureteGrainTaux: 'TAUX_IMPURETE_MITADINE_GERME',
  impureteTaux: 'TAUX_IMPURETE',
  insectePresent: 'PRESENCE_INSECTE',
  matiereGrasseTaux: 'TAUX_MATIERE_GRASSE',
  mitadineTaux: 'TAUX_MITADINE',
  omega3Taux: 'TAUX_OMEGA_3',
  poidsSpecifiqueEnKgParHectolitre: 'POIDS_SPECIFIQUE_EN_KG_PAR_HECTOLITRE',
  proteineTaux: 'TAUX_PROTEINE',
  temperatureEnDegreCelcius: 'TEMPERATURE_EN_CELSIUS',
  tempsChuteHacbergEnSeconde: 'TEMPS_CHUTE_HAGBERG_EN_SECONDE',
  zelenyIndiceEnMillilitre: 'INDICE_ZELENY_EN_MILLILITRE'
}
export default caracteristiques
